<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('groupChatResponsible.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('groupChatResponsible.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div>
            <ts-button color="info" outline @click="addNew">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div>
            <div class="d-flex justify-content-between">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 250px"
                class="inline-block"
              />
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'sub_program.acps_name_foreign',
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-nowrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.user.employee.name_en }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.sub_program.acps_name_foreign }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.remarks }}
            </td>
            <td class="text-center ts-space-x-3 ts-whitespace-nowrap">
              <!-- <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a> -->
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>

    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('groupChatResponsible.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      width="700px"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form.vue'
export default {
  name: 'bankProfileIndex',
  components: {
    FromAction,
  },
  data() {
    return {
      loading: false,
      showForm: false,
    }
  },
  computed: {
    ...mapState('groupChatResponsible', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.groupChatResponsible.search
      },
      set(newValue) {
        this.$store.commit('groupChatResponsible/SET_SEARCH', newValue)
        this.$store.commit('groupChatResponsible/RESET_CURRENT_PAGE')
      },
    },
    columns() {
      return [
        {
          name: this.$t('groupChatResponsible.branch'),
          style: 'white-space: nowrap;',
        },
        {
          name: this.$t('groupChatResponsible.response'),
          style: 'white-space: nowrap;',
        },
        {
          name: this.$t('groupChatResponsible.subProgram'),
          style: 'white-space: nowrap;',
        },
        {
          name: this.$t('groupChatResponsible.remarks'),
          style: 'white-space: nowrap;',
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 1px;',
        },
      ]
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('groupChatResponsible/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$notify({ type: 'error', text: error.message })
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('groupChatResponsible/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('groupChatResponsible/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('groupChatResponsible/destroy', record.id)
        .then((response) => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('groupChatResponsible/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData()
    })
  },
}
</script>
<style>
.table-status {
  display: table;
  border-collapse: collapse;
  border: none;
}
.table-status td {
  padding: 2px 4px;
  border-top: none !important;
  font-size: 10px;
}
table.table-status .icon {
  visibility: hidden;
}
table.table-status tr:hover .icon {
  visibility: visible;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-color: #e2e7eb;
  padding: 8px 10px;
}
.external-student {
  border-color: hsl(214, 100%, 59%);
  border-width: 2px;
}
</style>
